import React, { useEffect } from "react";
import Modal from "../../Modal";

const FileViewer = ({ fileUrl, hanldeClose }) => {
  // Extract the file extension for validation
  const getFileExtension = (url) => {
    if (!url) return "";
    return url.split(".").pop().toLowerCase();
  };

  const fileExtension = getFileExtension(fileUrl);
  const isValidFileType = ["pdf", "doc", "docx"].includes(fileExtension);
  useEffect(() => {
    if (fileUrl && isValidFileType) {
      const anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = ""; // Use this attribute to suggest a download
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  }, [fileUrl, isValidFileType]);
  return (
    <Modal>
      <div className="modal-body">
        <div className="Decline">
          <a className="CloseModal" onClick={hanldeClose}>
            ×
          </a>
          <div className="form-group">
            {fileUrl ? (
              isValidFileType ? (
                <>
                  <p
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                      textAlign: "center",
                    }}
                  >
                    Your file is being downloaded.
                  </p>
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    If the download didn’t start automatically,{" "}
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue", textDecoration: "underline" }}
                    >
                      click here to download the file.
                    </a>
                  </p>
                </>
              ) : (
                <p
                  className="error-message"
                  style={{
                    textAlign: "center",
                    color: "red",
                    fontWeight: "bold",
                    margin: "50px 0",
                  }}
                >
                  Error: File is not a valid PDF or DOC type.
                </p>
              )
            ) : (
              <p
                style={{
                  textAlign: "center",
                  margin: "50px 0",
                }}
              >
                No file to display.
              </p>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FileViewer;
